import {Component, OnDestroy, OnInit} from '@angular/core';
import {FileExportsService} from '../../services/file-exports.service';
import {Subscription} from 'rxjs/Subscription';
import {Page} from '../../model/page';
import {Title} from '@angular/platform-browser';
import {ToastrService} from 'ngx-toastr';
import * as _ from 'lodash';

@Component({
    selector: 'app-file-exports',
    templateUrl: './file-exports.component.html',
    styleUrls: ['./file-exports.component.scss'],
    providers: [
        FileExportsService
    ],
    preserveWhitespaces: true
})
export class FileExportsComponent implements OnInit, OnDestroy {

    private subscription: Subscription;
    public page = new Page();

    public cols: Array<any>;
    public rows: Array<any>;
    public statusOptions: Array<any>;
    public typeOptions: Array<any>;
    public totalRecords: number;
    public filters: { [key: string]: any; };
    public filtersApplied: boolean;
    public loading: boolean;
    private viewInitialized: boolean;

    public fileExportsServiceRef = FileExportsService;

    constructor(
        private fileExportsService: FileExportsService,
        private title: Title,
        private toast: ToastrService
    ) {
        this.page.pageNumber = 0;
        this.page.size = 50;
        this.title.setTitle('File Exports');
    }

    ngOnInit() {
        this.initValues();
        this.autoRefresher();
    }

    initValues() {
        this.cols = [
            { field: 'FE1_TYPE', header: 'Type', visible: true, filter: true, width: 150 },
            { field: 'FE1_CREATED_ON', header: 'Requested On', visible: true, filter: false, width: 100 },
            { field: 'FE1_DETAILS', header: 'Details', visible: true, filter: false, width: 250 },
            { field: 'FE1_STATUS', header: 'Status', visible: true, filter: true, width: 150 },
            { field: 'FE1_EXPIRATION', header: 'Expires On', visible: true, filter: false, width: 100 }
        ];
        this.rows = [];
        this.statusOptions = this.fileExportsService.getStatusOptions();
        this.typeOptions = this.fileExportsService.getTypeOptions();
        this.totalRecords = 0;
        this.filters = {};
        this.filtersApplied = false;
        this.loading = false;
        this.viewInitialized = true;
    }

    getData() {
        this.loading = true;
        this.subscription = this.fileExportsService.getItems(this.page).subscribe(result => {
            this.rows = result.data.map(record => {
                record['FE1_TYPE'] = Number(record['FE1_TYPE']);
                record['FE1_STATUS'] = Number(record['FE1_STATUS']);
                return record;
            });
            this.totalRecords = result.count;
            this.loading = false;
        }, () => {
            this.toast.error('Request timed out.', 'Service Error');
            this.loading = false;
        });
    }

    refreshClick() {
        this.rows = [];
        this.getData();
    }

    onPage(event) {
        this.page.pageNumber = event.first / event.rows;
        this.getData();
    }

    applyFilters() {
        const filters = _.clone(this.filters);
        for (const filterKey of Object.keys(filters)) {
            if (filters[filterKey] == null || filters[filterKey] === undefined || filters[filterKey] === '') {
                delete filters[filterKey];
            }
        }
        this.filtersApplied = Object.keys(filters).length > 0;
        this.page.filterParams = filters;

        this.page.pageNumber = 0;
        this.getData();
    }

    clearFilters() {
        this.filters = {};
        this.filtersApplied = false;

        this.applyFilters();
    }

    ngOnDestroy() {
        this.viewInitialized = false;
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    downloadFile(fileExport) {
        if (fileExport.FE1_STATUS === this.fileExportsServiceRef.STATUS_READY) {
            this.fileExportsService.downloadFile(fileExport.FE1_ID, fileExport.FE1_FILENAME);
        }
    }

    autoRefresher() {
        if (!this.viewInitialized) {
            return;
        }
        this.getData();
        setTimeout(() => {
            this.autoRefresher();
        }, 30000);
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/file-exports/file-exports.component.ts